export const anet = {
  data: function () {
    return {
      inProgress: false
    }
  },
  methods: {
    getNonce: function (cardNumber, expMonth, expYear, cardCode, responseHandler) {
      var authData = {}
      authData.clientKey = '5VLXFaBRqsqM4w4QybN9M7KW3zsug466vhxhM84YRQm26bZheJdEQ3gdHp3bZuFZ'
      authData.apiLoginID = '65jUFHbj4b38'

      var cardData = {}
      cardData.cardNumber = cardNumber
      cardData.month = expMonth
      cardData.year = expYear
      cardData.cardCode = cardCode

      var secureData = {}
      secureData.authData = authData
      secureData.cardData = cardData

      Accept.dispatchData(secureData, responseHandler)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/clients/anet.js